import http from '@/services/http.service';

class GiveUpService {
  save(orderId: string, payload: any) {
    return http.patch(`/order/${orderId}/give-up`, payload);
  }
}

export default new GiveUpService();
